import script from "./Journaling.vue?vue&type=script&setup=true&lang=ts"
export * from "./Journaling.vue?vue&type=script&setup=true&lang=ts"

import "./Journaling.vue?vue&type=style&index=0&id=67cb3ed6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cb3ed6"]])

export default __exports__